module.exports = __webpack_public_path__ + "static/media/hairDryerIcon.23f43935.svg";